import React, { useEffect, useState } from 'react'
import { useOktaAuth } from '@okta/okta-react'

const LoginCallback: React.FC = () => {
  const { oktaAuth } = useOktaAuth()
  const [error, setError] = useState('')

  useEffect(() => {
    const handleLoginRedirect = async () => {
      try {
        await oktaAuth.handleRedirect()
      } catch (err) {
        console.error('Login callback error:', err)
        setError('Authentication failed. Please try again.')
        
        // Redirect back to main page after error
        setTimeout(() => {
          window.location.href = '/'
        }, 3000)
      }
    }

    handleLoginRedirect()
  }, [oktaAuth])

  if (error) {
    return (
      <div className="container">
        <div className="error">{error}</div>
        <p>Redirecting you back...</p>
      </div>
    )
  }

  return (
    <div className="container">
      <div className="loading" />
      <p>Completing authentication...</p>
    </div>
  )
}

export default LoginCallback
